import { Grid, Typography } from "@mui/material";

import { CallOffCodeChips } from "domains/partitions/components";
import { NodePath } from "domains/nodes/components/node-path";
import localisations from "../../../localisation";

function ConfirmationStage(props: any) {
    const { heading,
        blurb,
        pathLabel,
        partitionParent,
        partitionName,
        reference,
        emailAddress,
        notes,
        callOfCodes } = localisations.createPartition.stages.confirmation;
    const fields = props.fields;

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>

            <Grid spacing={1} container style={{ marginTop: 10 }}>
                <Grid display="inline" item xs={12}>
                    <Typography display="inline">
                        {partitionParent}:
                    </Typography>
                    <NodePath textDisplay="inline" showAsText nodeId={fields.parentHierarchyNodeId ?? null} labelText={pathLabel}></NodePath>
                    <Typography>
                        {partitionName}: {fields.name ?? null}
                    </Typography>
                    <Typography>
                        {reference}: {fields.reference ?? null}
                    </Typography>
                    <Typography>
                       {emailAddress}: {fields.emailAddress ?? null}
                    </Typography>
                    <Typography>
                        {notes}: {fields.notes ?? null}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <CallOffCodeChips title={callOfCodes} deletable={false} callOffCodes={fields.callOffCodes}></CallOffCodeChips>
                </Grid>
            </Grid>
        </>
    );
}

export default ConfirmationStage;
